// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 6118) return "static/chunks/6118-69af2a10f7557a22.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"4138":"e5bb1560f0dc706d","6147":"a4668bb76304808e"}[chunkId] + ".js";
};